import { Box, Chip, Typography } from '@mui/material'
import { CustomColumnGridConfig } from '../types'

// const getId = (row: any) =>
  // row?.id ?? row?._id ?? row?.key ?? row?.uid ?? row?.guid

const numOrNull = (v: any) => {
  const n = Number(v)
  return Number.isFinite(n) ? n : null
}

const computeTableValue = (row: any) => {
  const start = numOrNull(row?.startPeriod)
  const end = numOrNull(row?.endPeriod)
  if (start != null && end != null) return +(end - start).toFixed(3)

  const arr: any[] = Array.isArray(row?.dailyUsageData)
    ? row.dailyUsageData
    : []
  if (arr.length >= 2) {
    const first = numOrNull(arr[0])
    const last = numOrNull(arr[arr.length - 1])
    if (first != null && last != null) return +(last - first).toFixed(3)
  }
  return null
}
const pad2 = (n: number) => String(n).padStart(2, '0')

const formatDateTime = (d: Date) =>
  `${pad2(d.getDate())}/${pad2(d.getMonth() + 1)}/${d.getFullYear()} ${pad2(d.getHours())}:${pad2(d.getMinutes())}`

const parseDateLike = (v: any): Date | null => {
  if (!v) return null
  if (v instanceof Date) return v
  if (typeof v === 'number' && Number.isFinite(v)) return new Date(v)
  if (typeof v === 'string') {
    const m = v.match(/^(\d{2})\/(\d{2})\/(\d{4})(?:[ T](\d{2}):(\d{2}))?$/)
    if (m) {
      const [, dd, MM, yyyy, HH = '00', mm = '00'] = m
      return new Date(+yyyy, +MM - 1, +dd, +HH, +mm)
    }
    const d = new Date(v)
    return isNaN(d.getTime()) ? null : d
  }
  return null
}

const getLastValueDate = (row: any): Date | null => {
  const candidates = [
    row?.lastValueDateTime,
    row?.lastValueAt,
    row?.lastSeen,
    row?.lastReadAt,
    row?.lastTimestamp,
    row?.updatedAt,
    row?.lastDate,
  ]
  for (const c of candidates) {
    const d = parseDateLike(c)
    if (d) return d
  }
  return null
}

const graphColumnsConfig = (
  colorsMap: Map<string, string>
): CustomColumnGridConfig[] => [
  {
    field: 'name',
    headerName: 'שם',
    width: 220,
    flex: 1,
    renderCell: (params: any) => {
      const label = params?.value ?? '—'
      return (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
            gap: 1,
            width: '100%',
          }}
        >
          <Chip
            label={label}
            size="small"
            sx={{
              bgcolor: colorsMap.get(params.id),
              color: '#fff',
              fontWeight: 700,
              borderRadius: '999px',
              px: 1,
              height: 24,
              '& .MuiChip-label': { px: 1 },
            }}
          />
          <Chip
            size="small"
            label=""
            sx={{
              bgcolor: '#E6F0FF',
              color: '#4C9EEB',
              height: 24,
              '& .MuiChip-label': { px: 0 },
            }}
          />
        </Box>
      )
    },
    filter: { type: 'search' },
    disableAggregation: true,
    hideable: true,
    filterable: true,
  },

  {
    field: 'address',
    headerName: 'כתובת',
    width: 140,
    flex: 1,
    renderCell: (p: any) => (
      <Typography sx={{ color: '#003F61', fontFamily: 'Rubik, sans-serif' }}>
        {p?.value ?? '—'}
      </Typography>
    ),
    filter: { type: 'search' },
    disableAggregation: true,
    hideable: true,
    filterable: true,
  },

  {
    field: 'endUnitNumber',
    headerName: "מס' יחידת קצה",
    width: 200,
    flex: 1,
    filter: { type: 'search' },
    disableAggregation: true,
    hideable: true,
    filterable: true,
  },

  {
    field: 'tableValue',
    headerName: 'ערך אחרון',
    width: 140,
    flex: 1,
    renderCell: (params: any) => {
      const row = params?.row ?? {}
      const val = computeTableValue(row)
      const text = val == null ? '—' : `${val.toFixed(3)}`
      return (
        <Typography
          sx={{
            fontWeight: 700,
            color: colorsMap.get(params.id),
            direction: 'ltr',
            fontFamily: 'Rubik, sans-serif',
          }}
        >
          {text}
        </Typography>
      )
    },
    filter: { type: 'none' },
    disableAggregation: true,
    hideable: true,
  },
  {
    field: 'lastValueDateTimeDisplay',
    headerName: 'תאריך ערך אחרון',
    width: 200,
    flex: 1,
    valueGetter: (params: any) => {
      const d = getLastValueDate(params?.row ?? {})
      return d ? d.getTime() : null
    },
    renderCell: (params: any) => {
      const d = getLastValueDate(params?.row ?? {})
      const text = d ? formatDateTime(d) : '—'
      return (
        <Typography
          sx={{
            direction: 'ltr',
            fontFamily: 'Rubik, sans-serif',
            color: '#003F61',
            fontSize: '13px',
          }}
        >
          {text}
        </Typography>
      )
    },
    sortComparator: (a: number | null, b: number | null) => (a ?? 0) - (b ?? 0),
    filter: { type: 'search' },
    disableAggregation: true,
    hideable: true,
    filterable: true,
  },
]

export default graphColumnsConfig
